import script from "./ChangePasswordPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangePasswordPage.vue?vue&type=script&setup=true&lang=ts"

import "./ChangePasswordPage.vue?vue&type=style&index=0&id=7faf429a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7faf429a"]])

export default __exports__